
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');


/**
 * Import Alpine, as required by v3
 */

import Alpine from "alpinejs";
window.Alpine = Alpine;
Alpine.start();

// window.Vue = require('vue');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// Vue.component('example-component', require('./components/ExampleComponent.vue'));

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key)))

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// const app = new Vue({
//     el: '#app'
// });

$(document).ready(function() {

    if ($('html').prop('lang') === 'en') {
        window.locale = 'en';
    } else {
        window.locale = 'ja';
    }

    $('form[data-confirm]').submit(event => window.swalConfirm(event));
    $('[data-toggle="tooltip"]').tooltip({});
    $('[data-tt="tt"]').tooltip({});
    $('[data-toggle="popover"]').popover();
    $('[data-s2="true"]').select2();
    $('[data-date-input]').each(function() {

        let dateFormat = $(this).data('date-format');


        if (empty(dateFormat)) {
            dateFormat = 'YYYY-MM-DD';
        }

        // console.log(this);
        // console.log($(this).data('date-format'));
        // console.log('initializing pikaday with date format ' + dateFormat);

        new Pikaday({
            field: this,
            format: dateFormat,
            i18n: {
                previousMonth : '前の月',
                nextMonth     : '次の月',
                months        : ['１月','２月','３月','４月','５月','６月','７月','８月','９月','１０月','１１月','１２月'],
                weekdays      : ['日曜日','月曜日','火曜日','水曜日','木曜日','金曜日','土曜日'],
                weekdaysShort : ['日','月','火','水','木','金','土']
            }
        })
    });
    $("[role='tablist']").each(function() {
        if ($(this).find('.active').length === 0) {
            $(this).find('[data-toggle="tab"]').first().tab('show');
        }
    })

    let dts = $('table.dt');

    if (document.documentElement.lang === 'ja') {
        $(dts).dataTable({
            language: {
                "sEmptyTable": "テーブルにデータがありません",
                "sInfo": " _TOTAL_ 件中 _START_ から _END_ まで表示",
                "sInfoEmpty": " 0 件中 0 から 0 まで表示",
                "sInfoFiltered": "（全 _MAX_ 件より抽出）",
                "sInfoPostFix": "",
                "sInfoThousands": ",",
                "sLengthMenu": "_MENU_ 件表示",
                "sLoadingRecords": "読み込み中...",
                "sProcessing": "処理中...",
                "sSearch": "検索:",
                "sZeroRecords": "一致するレコードがありません",
                "oPaginate": {
                    "sFirst": "先頭",
                    "sLast": "最終",
                    "sNext": "次",
                    "sPrevious": "前"
                },
                "oAria": {
                    "sSortAscending": ": 列を昇順に並べ替えるにはアクティブにする",
                    "sSortDescending": ": 列を降順に並べ替えるにはアクティブにする"
                }
            },
            rowCallback: setRowIndex
        });
    }
    else {
        $(dts).dataTable({
            rowCallback: setRowIndex
        });
    }

    $(dts).on('draw.dt', autoResizeTextareas);

    new ClipboardJS('.copy-btn');
    window.autoResizeTextareas();
});

function setRowIndex( row, data, displayNum, displayIndex, dataIndex )
{
    $(row).children('td[data-index-cell]').html(displayIndex + 1);
}

/*
 * helper function
 */

window.toggleDivs = function(divA, divB) {
    $(divA).toggleClass('d-none');
    $(divB).toggleClass('d-none');
};

window.disableAndHide = function (element, hide) {
    $(element).prop('disabled', hide).toggleClass('d-none', hide);
};

window.empty = function(mixedVar) {
    //  discuss at: http://locutus.io/php/empty/

    // let undef;
    let key;
    let i;
    let len;
    const emptyValues = [undefined, null, false, 0, '', '0'];

    for (i = 0, len = emptyValues.length; i < len; i++) {
        if (mixedVar === emptyValues[i]) {
            return true
        }
    }

    if (typeof mixedVar === 'object') {
        for (key in mixedVar) {
            if (mixedVar.hasOwnProperty(key)) {
                return false
            }
        }
        return true
    }

    return false
};

window.trim = function (str) {
    return str.replace(/^\s+|\s+$/g, '');
};


window.sleep = function(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
};

window.fixedAlert = async function(type, message) {

    let alert = $('<div class="alert alert-' + type + ' alert-dismissible fade show" role="alert">' + message +
        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        '<span aria-hidden="true">&times;</span>' +
        '</button>' +
        '</div>');

    $('#fixed-container-inner').append(alert);

    await sleep(10000);

    alert.alert('close');
};

window.autoDismissAlerts = async function(selector) {

    await sleep(5000);

    $(selector).alert('close');
}

window.parseAjaxError = function (error) {
    let html = '<ul class="error-list">';
    let errorsList = error.response['errors'];

    _.forOwn(errorsList, function (value, key) {
        _.forOwn(value, function (error, type) {
            html += '<li>' + error + '</li>';
        });
    });

    html += '</ul>';

    window.fixedAlert('danger', html);
};

window.autoResizeTextareas = function()
{
    $('textarea[data-autoresize="true"]').each(function () {

        if ($(this).val().length > 0 && this.scrollHeight > 0) {
            this.setAttribute('style', 'height:' + (this.scrollHeight) + 'px; overflow-y:hidden;');
        }

    }).on('input', function () {
        this.style.height = 'auto';
        this.style.height = (this.scrollHeight) + 'px';
    });
};

window.swalConfirm = function(e)
{
    e.preventDefault();

    const lang = {
        'ja': {
            title: 'ご確認ください',
            text: '取り消しはできません。',
            confirmButtonText: 'OK',
            cancelButtonText: 'キャンセル'
        },
        'en': {
            title: 'Are you sure?',
            text: 'You won\'t be able to revert this.',
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel'
        },
    };

    let settings = {
        ...lang[window.locale],
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#28a745',
        cancelButtonColor: '#999',
        reverseButtons: true,
        showClass: {
            popup: ''
        },
    };

    if ($(e.target).data('swal-text')) {
        settings['text'] = $(e.target).data('swal-text');
    }

    Swal
        .fire(settings)
        .then((result) => {
            if (result.value) {
                e.target.submit();
            }
        });
};

window.bsModal = function(id, options)
{
    $('#' + id).modal('show')
}

window.isLoggedIn = function(url)
{
    setTimeout(function() {
        axios.get(url)
            .then(function (response) {
                if (response.data === false) {
                    $('#session-expired-alert').modal('show');
                } else {
                    window.isLoggedIn(url);
                }
            });
    }, 30000);
}

window.togglePreview = function(row, prefix)
{
    let hide = $(row).hasClass('selected');

    $('.' + prefix + '-row').removeClass('selected');
    $('.' + prefix + '-preview').addClass('d-none');

    if (hide) {
        $('#' + prefix + '-preview-placeholder').removeClass('d-none');
    }
    else {
        $(row).toggleClass('selected');
        $('#' + prefix + '-preview-' + $(row).data(prefix + '-id')).removeClass('d-none');
    }
}

window.initDatePicker = function(input)
{
    new Pikaday({field: input});
}


/*
DataTables helpers
 */

window.getTableRows = function(selector = null, filtered = false)
{
    let args = filtered
        ? {filter: 'applied'}
        : {};

    selector ??= 'table.dt';

    return $(selector).DataTable().rows(args).nodes().to$();
}
